import { render, staticRenderFns } from "./JianKang.vue?vue&type=template&id=12f94a5b&scoped=true"
import script from "./JianKang.vue?vue&type=script&lang=js"
export * from "./JianKang.vue?vue&type=script&lang=js"
import style0 from "./JianKang.vue?vue&type=style&index=0&id=12f94a5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f94a5b",
  null
  
)

export default component.exports